import { useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { interpolateString } from "domains/language/interpolate";
import { getSiteLanguage, getSiteLanguageLabel } from "domains/language/selectors";

type UseTranslationLinkParams = {
  id?: string;
  title?: string;
  language?: string;
  link?: string;
};

export const useTranslationLink = ({ id, title, language, link }: UseTranslationLinkParams) => {
  const siteLanguage = useSelector(getSiteLanguage);
  const siteLanguageLabel = useSelector(getSiteLanguageLabel);
  const track = useTrack();
  const translate = useTranslate();

  return !id
    ? { displayTranslationLink: false }
    : {
        displayTranslationLink: language !== siteLanguage,
        onTranslationLinkClick: () =>
          track({
            articleLanguage: language,
            entityId: id,
            entityName: title,
            entityType: "Knowledge",
            name: "Open Translation Link",
          }),
        translationLinkLabel: interpolateString(translate("app.view_article.translated"), {
          language: () => siteLanguageLabel,
        }),
        translationUrl: `https://translate.google.com/translate?sl=auto&tl=${siteLanguage}&u=${encodeURIComponent(link ?? "")}`,
      };
};
